import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { Injectable, NgModule } from "@angular/core";

import { HsPanelHelpersModule } from "hslayers-ng";
import { AcStrategyComponent } from "./strategy.component";

import { ChartsModule } from "../charts/charts.module";
import {
  NgbDateParserFormatter,
  NgbDatepickerModule,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";

/**
 * Formats date in ngDatePicker input
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = ".";
  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? date.day + this.DELIMITER + date.month : "";
  }
}

@NgModule({
  declarations: [AcStrategyComponent],
  imports: [
    BrowserModule,
    FormsModule,
    HsPanelHelpersModule,
    ChartsModule,
    NgbDatepickerModule,
  ],
  exports: [AcStrategyComponent],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  entryComponents: [],
})
export class StrategyModule {}
